<div
  *ngIf="!!currentParentOrganisation"
  tuiDropdownOpen
  class="association-menu__wrap"
  [tuiDropdown]="associationMenuTmpl"
  [tuiDropdownSided]="true"
>
  <div class="association-menu">
    <tui-avatar
      class="association-menu__icon"
      [src]="
        currentParentOrganisation.photoId
          | getImageSrc
          | tuiFallbackSrc: (currentParentOrganisation.shortName || '' | tuiInitials)
          | async
      "
      [style.background]="
        !currentParentOrganisation.photoId && currentParentOrganisation.shortName
          ? (currentParentOrganisation.shortName | tuiAutoColor)
          : ('' | tuiAutoColor)
      "
      [size]="mode === 'desktop' ? 'm' : 's'"
      [round]="true"
    ></tui-avatar>

    <div *ngIf="mode === 'desktop' && isOpen" class="association-menu__text-box">
      <div *ngIf="currentParentOrganisation.shortName" class="association-menu__title">
        {{ currentParentOrganisation.shortName }}
      </div>
    </div>
  </div>
</div>

<ng-template #associationMenuTmpl>
  <tui-data-list *ngIf="parentOrganisations$ | async as parentOrganisations" class="association-menu__list">
    <tui-opt-group [label]="'components.navigation.labels.associationMenu' | translate">
      <button
        *ngFor="let parentOrganisation of parentOrganisations"
        tuiOption
        class="association-menu-item"
        (click)="changeCurrentParentOrganisation(parentOrganisation)"
      >
        <tui-badged-content [style.--tui-radius.%]="50">
          <tui-badge-notification
            *ngIf="parentOrganisation.id === currentParentOrganisation?.id"
            tuiSlot="top"
            [size]="'s'"
            [style.background-color]="'var(--tui-status-positive)'"
          ></tui-badge-notification>

          <tui-avatar
            [src]="
              parentOrganisation.photoId
                | getImageSrc
                | tuiFallbackSrc: (parentOrganisation.shortName || '' | tuiInitials)
                | async
            "
            [style.background]="
              !parentOrganisation.photoId && parentOrganisation.shortName
                ? (parentOrganisation.shortName | tuiAutoColor)
                : ('' | tuiAutoColor)
            "
            [round]="true"
            [size]="'s'"
          ></tui-avatar>
        </tui-badged-content>

        <span class="association-menu-item__title">
          {{ parentOrganisation.shortName || '' }}
        </span>
      </button>
    </tui-opt-group>
  </tui-data-list>
</ng-template>
